import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AgentsIcon extends BaseIcon {
  getChildren = () => [<path fill={ this.getColor() }
                             d='M13.19,13.69,8.58,16H7.42L2.81,13.69.5,4.46,7.42,1H8.5l7,3.46Z'/>]
  getViewBox = () => '0 0 16 16'
}
